import { useAppKit } from '@reown/appkit/react';
import { mainnet, bsc } from '@reown/appkit/networks';
import { useNetworkModal } from '../components/NetworkModal';
import { useConfig, useSwitchChain } from 'wagmi';

export function useNetworkSwitch() {
  const { switchChain } = useSwitchChain();
  const config = useConfig();
  const { setOpen: openNetworkModal } = useNetworkModal();

  const switchToNetwork = async (networkId: 'eth' | 'bsc') => {
    try {
      let chainId: number;
      
      if (networkId === 'eth') {
        chainId = mainnet.id;
      } else if (networkId === 'bsc') {
        chainId = bsc.id;
      } else {
        throw new Error('Unsupported network');
      }

      // Check if chain exists in config
      const chain = config.chains.find((x) => x.id === chainId);
      if (!chain) {
        throw new Error('Chain not configured');
      }

      // Switch chain using wagmi's switchChain
      await switchChain({ chainId });

    } catch (error) {
      console.error('Failed to switch network:', error);
      // Re-throw the error to be handled by the UI
      throw error;
    }
  };

  return { switchToNetwork };
}